import { useState, useCallback } from 'react'

export interface DrawerState {
  isOpen: boolean
  open: () => void
  close: () => void
  toggle: () => void
}

/**
 * Reusable hook for managing drawer open/close state
 * Save this example for my own saninity - Danh
 *
 * @example
 * const notesDrawer = useDrawerState()
 *
 * <Button onClick={notesDrawer.open}>Open Notes</Button>
 * <Drawer open={notesDrawer.isOpen} onClose={notesDrawer.close} />
 */

export function useDrawerState(initialOpen = false): DrawerState {
  const [isOpen, setIsOpen] = useState(initialOpen)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])
  const toggle = useCallback(() => setIsOpen(prev => !prev), [])

  return { isOpen, open, close, toggle }
}
